import { render, staticRenderFns } from "./ClienteListaLocaisEntrega.vue?vue&type=template&id=2171bba0&scoped=true"
import script from "./ClienteListaLocaisEntrega.vue?vue&type=script&lang=js"
export * from "./ClienteListaLocaisEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2171bba0",
  null
  
)

export default component.exports